import ThumbsDown from 'components/Common/ThumbsDown';
import Share from 'components/Dashboard/components/Share';
import useIsMobile from 'components/Dashboard/utilities/useIsMobile';
import { useContentResults } from 'components/Dashboard/ContentResultsContext';
import React from 'react';

const RegulationDocumentBar = () => {
  const { contentResults } = useContentResults();
  const regulationDocument = contentResults?.RegulationDocuments?.new ?? null;
  const { id, title, objectId, objectType, canonicalUrl } = regulationDocument ?? {};
  const isMobile = useIsMobile();

  const item = {
    id,
    title,
    objectID: objectId,
    type: objectType,
  };
  return (
    <div className={`bg-white monitor-items-bar inbox-items-bar`}>
      <div className='mx-auto main-content-wrapper flex-centered justify-content-between resize-elements-container'>
        <div
          className={`main-content flex-centered position-relative filters-general-container justify-content-${isMobile ? 'end' : 'between'} key-update-content`}
        >
          <div className={`flex-centered justify-content-between stakeholder-sub-nav text-overflow-ellipsis`}>
            <p
              data-tooltip-content={regulationDocument?.title}
              data-tooltip-id='general-tooltip'
              data-tooltip-class-name='header-tooltip tooltip-width-300'
              data-tooltip-place='bottom'
              className='title-h3 nowrap-item mb-0 text-main-blue font-weight-bold text-overflow-ellipsis'
            >
              {regulationDocument?.title}
            </p>
          </div>
          <div className='row mx-0 justify-content-between align-items-center'>
            <div className='flex-centered'>
              <ThumbsDown
                item={{ objectID: regulationDocument?.objectId }}
                nameSection='Regulations'
                show={!!regulationDocument?.keywordsFromLists}
                contentPage={true}
                alreadyMarked={!!regulationDocument?.feedback}
                keywordsFromLists={regulationDocument?.keywordsFromLists}
                thick={true}
              />
              <Share
                item={item}
                id={id}
                title={title}
                link={canonicalUrl ? `${import.meta.env.VITE_APP_APPURL}${canonicalUrl}` : undefined}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegulationDocumentBar;
